import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { navigate } from 'gatsby';
import Loadable from '@loadable/component';
import { apiHolder, inWindow, apis, getIn18Text, conf } from 'api';
import { useAppDispatch, useAppSelector, useActions } from '@web-common/state/createStore';
import { safeDecodeURIComponent, getWaimaoTrailEntryHost } from '@web-common/utils/utils';
import useWatermark from '@web-common/hooks/useWatermark';
import LoadingWithMenu from '@/components/Layout/tab-loading/with-menu';
import LoadingNoMenu from '@/components/Layout/tab-loading/no-menu';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import useRiskConfirm from '@web-common/hooks/useRiskConfirm';
import debounce from 'lodash/debounce';
import dayjs from 'dayjs';
import AlertPublishSiteModal from '@web-site/components/AlertModal';
import SubAccEntryGuide from '@web-mail/components/ColumnMailBox/SubAccEntryGuide';
import { UnitableCrmLinghang } from '@web-unitable-crm/linghang-unitable-crm';
import MailBox from '@web-mail/mailBox';
import { L2cCrmPageType } from '@web-common/conf/waimao/l2c-crm-constant';
import { useL2cCrmSidebarMenu } from '@web-common/hooks/use-l2c-crm-menu-data';
import { isMatchUnitableCrmHash, unitableManageRouteActiveKey, unitablePerformanceRouteActiveKey } from '@web-unitable-crm/api/helper';
import { KeyboardModel } from '@web-setting/Keyboard/keyboard';
import { CalenderIcon, ContactIcon, DiskTabIcon, IMIcon, MailBoxIcon, BigDataIcon, IntelliMarketingIcon, CustomerIcon, BusinessIcon, BusinessExecIcon, WorktableIcon, EnterpriseIcon, SiteIcon, SystemTaskIcon, WaTabIcon, AiStaffIcon, CoopIcon, BackgroundCheckIcon, } from '@web-common/components/UI/Icons/icons';
import { FloatButtonRoot } from '@web-common/components/FloatToolButton';
import { AiAssiBallEntry } from '@web-ai-asst-wm/components/AiAssiBallEntry';
import { bindMiniAppModal } from '@web-common/components/AiMiniAppModal';
import TinymceTooltip from '@web-common/components/UI/TinymceTooltip/TinymceTooltip';
import { AntdConfig } from '@web-common/components/UI/Config/Config';
import { useCommonErrorEvent, useEventObserver } from '@web-common/hooks/useEventObserver';
import listenWriteMail from '@web-mail/components/listenWriteMail';
import { getIsSomeMenuVisbleSelector, getMenuSettingsAsync, getPrivilegeAsync, getVersionAsync, getMyRolesAsync } from '@web-common/state/reducer/privilegeReducer';
import { doSharedAccountAsync } from '@web-common/state/reducer/loginReducer';
import { useLocation } from '@reach/router';
import lodashGet from 'lodash/get';
import { useFreeWriteMailErrorHandler } from '@web-mail/components/PaidGuideModal/index';
import { NoviceTaskActions, WebEntryWmActions } from '@web-common/state/reducer';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { navigateToSchedule } from '@/layouts/Main/util';
import SiriusLayout from '@/layouts';
import UpgradeApp from '@/components/Electron/Upgrade';
import { Notice } from '@/components/UI/Notice/notice';
import { GlobalAdvertNotification } from '@/components/UI/GlobalAdvertNotification/GlobalAdvertNotification';
import NpsSurveyNew from '@/components/Npsmeter/nps-new';
import { showNoviceTaskCloseTip } from '@/components/Layout/TaskCenter/utils';
import { isMatchCustomerManageRoute, isMatchCustomerPerformanceRoute } from '@web-common/hooks/use-l2c-crm-menu-data';
import style from '../styles/pages/index.module.scss';
import SalesPitchPageHoc from '@/components/Layout/EnterpriseSetting/salesPitch';
import { MarketingModalList } from '@web-edm/components/MarketingModalList/marketingModalList';
import { useEventsRegister } from '@/components/Layout/globalSearch/hook/useEventsRegister';
import UserPortraitModal from '@/components/Layout/globalSearch/component/UserPortraitModal';
import useMenuBadge from '@web-common/hooks/useMenuBadge';
import { allMenus } from '@web-common/conf/waimao/menu';
import { TopMenuPath, WAIMAO_PRODUCT_VERSIONS } from '@web-common/conf/waimao/constant';
import { getWaFrameworkVersion } from '@web-common/state/reducer/configReudcer';
import ChangeLxTrafficLabelModal from '@web-common/components/ChangeLxTrafficLabelModal';
import { useAiStaffInfo } from '@web-ai-staff/hooks/useAiStaffInfo';
import { getAiPageActive } from '@web-ai-staff/utils';
import NoticeLiveMessage from '@web-notify/components/NoticeLiveMessage';
import WaChatWindow from '@web-wa/components/WaChatWindow';
const loadableOption = {
    fallback: React.createElement(LoadingNoMenu, null),
};
const menuLoadableOption = {
    fallback: React.createElement(LoadingWithMenu, null),
};
const Schedule = Loadable(() => import('@web-schedule/schedule'), process.env.BUILD_ISEDM ? loadableOption : undefined);
const Disk = Loadable(() => import('@web-disk/index'), process.env.BUILD_ISEDM ? loadableOption : undefined);
const Setting = Loadable(() => import('@web-setting/index'), process.env.BUILD_ISEDM ? menuLoadableOption : undefined);
const Contact = Loadable(() => import('@web-contact/contact'), process.env.BUILD_ISEDM ? loadableOption : undefined);
const IM = Loadable(() => import('@web-im/im'), process.env.BUILD_ISEDM ? loadableOption : undefined);
const isLingxiWeb = process.env.BUILD_ISWEB && process.env.BUILD_ISLINGHANG && conf('profile').indexOf('webmail') === -1;
const Site = Loadable(() => import('@web-site/index'), menuLoadableOption);
const UnitableCrm = Loadable(() => import('@web-unitable-crm/unitable-crm'), Object.assign({ resolveComponent: commponents => commponents.UnitableCrm }, menuLoadableOption));
const Worktable = Loadable(() => import('@web-worktable/pages/Worktable'), Object.assign({ resolveComponent: components => components.Worktable }, loadableOption));
const BigData = Loadable(() => import('@/components/Layout/SceneAggregation/bigData'), menuLoadableOption);
const Coop = Loadable(() => import('@/components/Layout/SceneAggregation/coop'), menuLoadableOption);
const IntelliMarketing = Loadable(() => import('@/components/Layout/SceneAggregation/intelliMarketing'), menuLoadableOption);
const AiStaff = Loadable(() => import('@web-ai-staff/pages/Container'), Object.assign({ resolveComponent: components => components.Container }, menuLoadableOption));
const AiTeam = Loadable(() => import('@web-ai-staff/pages-ai-team/Container'), Object.assign({ resolveComponent: components => components.Container }, menuLoadableOption));
const SystemTask = Loadable(() => import('@/components/Layout/TaskCenter/pages/SystemTask'), loadableOption);
const NoviceTask = Loadable(() => import('@/components/Layout/TaskCenter/pages/NoviceTask'), loadableOption);
const NotificationCenter = Loadable(() => import('@web-notify/pages/NotificationCenter'), loadableOption);
const EmailInquiry = Loadable(() => import('@/components/Layout/EmailInquiry'), loadableOption);
const WhatsAppIndex = Loadable(() => import('@web-wa/index'), loadableOption);
const RbacSetting = Loadable(() => import('@/components/Layout/Rbac/rbac'), loadableOption);
const EnterpriseSetting = Loadable(() => import('@/components/Layout/EnterpriseSetting'), Object.assign({ resolveComponent: components => components.EnterpriseSetting }, loadableOption));
const BackgroundCheck = Loadable(() => import('@web-background-check/pages/index'), loadableOption);
if (inWindow()) {
    try {
        setTimeout(() => {
            IntelliMarketing.preload();
        }, 100);
    }
    catch (ex) {
        console.error('IntelliMarketing preload error', ex);
    }
}
console.info('---------------------from index page------------------');
const systemApi = apiHolder.api.getSystemApi();
const storeApi = apiHolder.api.getDataStoreApi();
const eventApi = apiHolder.api.getEventApi();
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const nimApi = apiHolder.api.requireLogicalApi('NIM');
const writeToPattern = /writeMailToContact=([0-9a-zA-Z%_#@\-.]+)/i;
const moduleNamePattern = /#(\/?[\w\d_-]+)((?=\?)|($))/;
const activeKeyVisitMap = {
    'unittable-crm-v2-pref': true,
    'unittable-crm-v2': true,
    'unitable-crm-v1': true,
};
const HOCEntry = (WrapElement, isSuspense = true) => {
    const ControlSuspenseComponent = props => {
        const { activeKey, name } = props;
        if (activeKey !== name) {
            return null;
        }
        if (isSuspense) {
            return (React.createElement(React.Suspense, { fallback: React.createElement("div", null, "loading...") },
                React.createElement(WrapElement, Object.assign({}, props))));
        }
        return React.createElement(WrapElement, Object.assign({}, props));
    };
    return ControlSuspenseComponent;
};
const visibleIM = nimApi.getIMAuthConfig();
const IMEntry = React.memo((props) => {
    const { activeKey, name } = props;
    const [enableRenderIM, setEnableRenderIM] = useState(false);
    useEffect(() => {
        setEnableRenderIM(flag => {
            if (flag) {
                return flag;
            }
            return activeKey === name;
        });
    }, [activeKey]);
    if (!enableRenderIM) {
        return null;
    }
    return React.createElement(IM, null);
}, (prevProps, props) => {
    if (lodashGet(props, 'activekey', '') === lodashGet(prevProps, 'activeKey', '')) {
        return true;
    }
    return lodashGet(props, 'activeKey', '') !== 'message';
});
const WaEntry = React.memo((props) => {
    const { activeKey, name } = props;
    const [enableRender, setEnableRender] = useState(false);
    useEffect(() => {
        setEnableRender(flag => {
            if (flag) {
                return flag;
            }
            return activeKey === name;
        });
    }, [activeKey]);
    if (!enableRender) {
        return null;
    }
    return React.createElement(WhatsAppIndex, Object.assign({}, props));
}, (prevProps, props) => lodashGet(props, 'activeKey', '') !== 'wa');
const MailEntry = React.memo(() => {
    const dispatch = useAppDispatch();
    const { hash } = useLocation();
    useEffect(() => {
        const eventId = listenWriteMail(dispatch);
        if (inWindow() && hash && writeToPattern.test(hash)) {
            const exec = writeToPattern.exec(hash);
            if (exec && exec[1]) {
                const writeTo = safeDecodeURIComponent(exec[1]);
                mailApi.doWriteMailToContact([writeTo]);
            }
        }
        return () => {
            eventApi.unregisterSysEventObserver('writeLatter', eventId);
        };
    }, []);
    return React.createElement(MailBox, null);
}, (prevProps, props) => {
    const { name = 'mail' } = props;
    if (lodashGet(props, 'activekey', '') === lodashGet(prevProps, 'activeKey', '')) {
        return true;
    }
    return lodashGet(props, 'activeKey', '') !== name;
});
const ScheduleEntry = HOCEntry(Schedule);
const lazyEntry = (Comp, activeName) => React.memo((props) => {
    const { activeKey, name } = props;
    const [enableRender, setEnableRender] = useState(false);
    useEffect(() => {
        setEnableRender(flag => {
            if (flag) {
                return flag;
            }
            return activeKey === name;
        });
    }, [activeKey]);
    if (!enableRender) {
        return null;
    }
    return React.createElement(Comp, Object.assign({}, props));
}, (prevProps, props) => lodashGet(props, 'activeKey', '') !== activeName);
const IMarketEntry = lazyEntry(IntelliMarketing, 'edm');
const AiStaffEntry = lazyEntry(AiStaff, 'aiStaff');
const AiTeamEntry = lazyEntry(AiTeam, 'aiTeam');
const BigDataEntry = React.memo((props) => {
    const { activeKey, name } = props;
    const [enableRender, setEnableRender] = useState(false);
    useEffect(() => {
        setEnableRender(flag => {
            if (flag) {
                return flag;
            }
            return activeKey === name;
        });
    }, [activeKey]);
    if (!enableRender) {
        return null;
    }
    return React.createElement(BigData, { name: name, redPoint: true, active: activeKey === 'wmData' });
}, (prevProps, props) => lodashGet(props, 'activeKey', '') !== 'wmData');
const ContactEntry = HOCEntry(Contact);
const DiskEntry = HOCEntry(Disk);
const SettingEntry = HOCEntry(Setting);
const IndexPageWrapper = ({ children, visibleUpgradeApp, upgradeInfo, setVisible, activeKey }) => (React.createElement(SiriusLayout.ContainerLayout, { isLogin: false, activeKey: activeKey },
    children,
    process.env.BUILD_ISELECTRON && visibleUpgradeApp === 2 ? React.createElement(UpgradeApp, { upgradeInfo: upgradeInfo, setVisibleUpgradeApp: setVisible }) : null));
const IndexPage = () => {
    const SalesPitchPage = useMemo(() => (process.env.BUILD_ISEDM ? SalesPitchPageHoc('settingBoard') : React.createElement(React.Fragment, null)), []);
    if (process.env.BUILD_ISEDM && process.env.BUILD_ISELECTRON) {
        useEventsRegister();
    }
    if (process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) {
        useMenuBadge(allMenus);
    }
    if (process.env.BUILD_ISELECTRON) {
        useEffect(() => {
            const eventName = 'mainWindowNavigate';
            const eid = eventApi.registerSysEventObserver(eventName, {
                name: `${eventName}-mainPage`,
                func: ev => {
                    if (ev && ev.eventData) {
                        const { url, state = {}, replace = false } = ev.eventData;
                        if (url) {
                            navigate(url, { state, replace });
                        }
                    }
                },
            });
            return () => eventApi.unregisterSysEventObserver(eventName, eid);
        }, []);
    }
    useEffect(() => {
        return bindMiniAppModal();
    }, []);
    const [selectedKeys, setSelectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const [accountActiveKey, setAccountActiveKey] = useState2RM('accountActiveKey', 'doUpdateAccountActiveKey');
    const [, setSelected] = useState2RM('mailListStateTab', 'doUpdateMailListStateTab');
    const dispatch = useAppDispatch();
    const [visibleUpgradeApp, setVisibleUpgradeApp] = useState(0);
    const [subAccGuideVisible, setSubAccGuideVisible] = useState(false);
    const [upgradeInfo, setUpgradeInfo] = useState();
    const [visibleKeyboardModel, setVisibleKeyboardModel] = useState(false);
    const version = useAppSelector(state => state.privilegeReducer.version);
    const navigateVersion = useAppSelector(state => state.privilegeReducer.navigateVersion === undefined ? (isLingxiWeb ? false : process.env.BUILD_ISLINGHANG) : state.privilegeReducer.navigateVersion);
    const refVisibleUpgradeApp = useRef(visibleUpgradeApp);
    const refVisibleKeyboardModel = useRef(visibleKeyboardModel);
    const addOtherMailHidden = useAppSelector(state => { var _a; return (_a = state.loginReducer.orgInfo) === null || _a === void 0 ? void 0 : _a.sirius_add_other_mail_hidden; });
    const addOtherMailHiddenRef = useRef(addOtherMailHidden);
    addOtherMailHiddenRef.current = addOtherMailHidden;
    const MemoizedTinymceTooltip = useMemo(() => TinymceTooltip, []);
    const isLingxi = process.env.BUILD_ISLINGXI;
    const [edmNotice, setEdmNotice] = useState(null);
    const [websiteInfo, setWebsiteInfo] = useState(null);
    const webSiteShow = useMemo(() => isLingxi && websiteInfo && websiteInfo.isShow, [isLingxi, websiteInfo]);
    const appDispatch = useAppDispatch();
    const globalSearchApi = apiHolder.api.requireLogicalApi(apis.globalSearchApiImpl);
    useEffect(() => {
        if (process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) {
            appDispatch(getMyRolesAsync());
        }
    }, []);
    const setVisible = process.env.BUILD_ISWEB
        ? (bool) => {
            console.log(bool);
        }
        : useCallback((bool) => {
            setVisibleUpgradeApp(bool ? 2 : 1);
        }, []);
    const preHandler = useFreeWriteMailErrorHandler();
    useCommonErrorEvent('indexCommonErrorOb', undefined, preHandler);
    useEventObserver('keyboard', {
        name: 'global-keyboard-listener',
        func: ev => {
            const { eventData } = ev;
            if (ev.eventStrData === 'global' && eventData) {
                if (eventData.action === 'visibleKeyboardModel') {
                    setVisibleKeyboardModel(true);
                }
                else if (eventData.action === 'navigate') {
                    if (eventData.module === 'schedule' && navigateToSchedule()) {
                        return;
                    }
                    navigate(eventData.url);
                }
            }
        },
    });
    useRiskConfirm();
    if (process.env.BUILD_ISELECTRON) {
        useEffect(() => {
            refVisibleUpgradeApp.current = visibleUpgradeApp;
        }, [visibleUpgradeApp]);
    }
    useEffect(() => {
        refVisibleKeyboardModel.current = visibleKeyboardModel;
    }, [visibleKeyboardModel]);
    useEffect(() => {
        if (process.env.BUILD_ISELECTRON) {
            eventApi.registerSysEventObserver('upgradeApp', {
                func: ev => {
                    var _a;
                    console.log('visibleUpgradeApp', ev, refVisibleUpgradeApp.current);
                    if ((_a = ev === null || ev === void 0 ? void 0 : ev.eventData) === null || _a === void 0 ? void 0 : _a.forcePopup) {
                        setVisibleUpgradeApp(2);
                    }
                    else {
                        refVisibleUpgradeApp.current === 0 && setVisibleUpgradeApp(2);
                    }
                    if (ev && ev.eventData) {
                        setUpgradeInfo(ev.eventData);
                    }
                },
            });
        }
    }, []);
    useEffect(() => {
        const eventId = eventApi.registerSysEventObserver('sharedAccountLogout', {
            name: 'mainpage-sharedAccoutLogout',
            func: _ => {
                setTimeout(() => {
                    dispatch(doSharedAccountAsync());
                }, 10);
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('sharedAccountLogout', eventId);
        };
    }, []);
    const { hash: currentHash } = useLocation();
    const defaultActiveKey = 'mailbox';
    const [activeKey, setActiveKey] = useState(defaultActiveKey);
    const [userPortraitHasInfo, setUserPortraitHasInfo] = useState(true);
    activeKeyVisitMap[defaultActiveKey] = true;
    const __hash__ = inWindow() ? window.location.hash : '';
    const isCrmRouteMatch = isMatchUnitableCrmHash(__hash__);
    const isCustomerManageRoute = isCrmRouteMatch && isMatchCustomerManageRoute(__hash__);
    if (isCustomerManageRoute) {
        activeKeyVisitMap['unittable-crm-v2'] = true;
    }
    const isCustomerPerformanceRoute = isCrmRouteMatch && isMatchCustomerPerformanceRoute(__hash__);
    if (isCustomerPerformanceRoute) {
        activeKeyVisitMap['unittable-crm-v2-pref'] = true;
    }
    const l2cCrmSidebarMenuExtra = useL2cCrmSidebarMenu();
    useEffect(() => {
        if (!currentHash || !currentHash.length) {
            return;
        }
        const matchedArr = currentHash.match(moduleNamePattern);
        let activeKey = '';
        if (isCustomerManageRoute) {
            activeKey = unitableManageRouteActiveKey;
            setActiveKey(activeKey);
            activeKeyVisitMap[activeKey] = true;
            return;
        }
        if (isCustomerPerformanceRoute) {
            activeKey = unitablePerformanceRouteActiveKey;
            setActiveKey(activeKey);
            activeKeyVisitMap[activeKey] = true;
            return;
        }
        if (!matchedArr) {
            return;
        }
        activeKeyVisitMap[matchedArr[1]] = true;
        setActiveKey(matchedArr[1]);
    }, [currentHash]);
    if (process.env.BUILD_ISELECTRON) {
        useEffect(() => {
            setTimeout(() => {
                systemApi.updateMainPageUrl();
            }, 100);
        }, [currentHash]);
    }
    const [visibleStyle] = useState({
        display: 'flex',
        flex: '1 1 0%',
        overflow: 'hidden',
        'content-visibility': 'visible',
    });
    const [hiddenStyle] = useState({
        display: 'none',
        'content-visibility': 'hidden',
    });
    const visibleWorktable = process.env.BUILD_ISLINGXI ? false : useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['WORKBENCH']));
    const visibleCustomerProspecting = process.env.BUILD_ISLINGXI
        ? false
        : useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['CUSTOMER_PROSPECTING']));
    const visilbeEnterpirseSetting = process.env.BUILD_ISLINGXI ? false : useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['ORG_SETTINGS']));
    const visibleWA = process.env.BUILD_ISEDM &&
        useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['WA_CHAT_MANAGE', 'WA_FILE_MANAGE', 'WA_CHAT_LIST', 'WHATSAPP_PERSONAL']));
    const visibleCUSTOMER_MANAGE = (process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) && useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['CUSTOMER_MANAGE']));
    const visibleCUSTOMER_PROMISE = process.env.BUILD_ISEDM && useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['CUSTOMER_PROMISE']));
    const visibleCUSTOMER_EXLOIT = process.env.BUILD_ISEDM && useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['CUSTOMER_EXLOIT']));
    const visibleCustomerBackgroundCheck = process.env.BUILD_ISLINGHANG && useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['CUSTOMER_INVERSTIGATION']));
    const visilbeSiteManager = process.env.BUILD_ISLINGXI ? false : useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['WEBSITE_ADMIN']));
    const aiStaffMenuVisible = useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['PERSONAL_AI_STAFF']));
    const aiTeamMenuVisible = useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['PERSONAL_AI_TEAM']));
    const visibleAiStaff = process.env.BUILD_ISEDM && aiStaffMenuVisible;
    const visibleAiTeam = process.env.BUILD_ISEDM && aiTeamMenuVisible;
    const { aiStaffKeepAlive, aiTeamKeepAlive } = useAppSelector(state => state.aiStaffReducer);
    useEffect(() => {
        const id = eventApi.registerSysEventObserver('edmGlobalNotice', {
            func: ev => {
                if (ev.eventData) {
                    setEdmNotice(ev.eventData);
                }
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('edmGlobalNotice', id);
        };
    }, []);
    useEffect(() => {
        if (!process.env.BUILD_ISEDM && !process.env.BUILD_ISLINGHANG) {
            return;
        }
        appDispatch(getPrivilegeAsync());
        appDispatch(getMenuSettingsAsync());
        appDispatch(getVersionAsync());
    }, [activeKey]);
    const judgeShowGuide = async (curKey) => {
        if (addOtherMailHiddenRef.current) {
            setSubAccGuideVisible(false);
            return;
        }
        if (curKey === 'mailbox' || curKey === 'worktable' || curKey.includes('unitable-crm')) {
            let frontAllow = false;
            const subAccGuideShowTime = storeApi.getSync('subAccGuideShowTime').data;
            if (!subAccGuideShowTime) {
                frontAllow = true;
            }
            else {
                const latestedSetTime = dayjs(Number(subAccGuideShowTime));
                const latestedMondy = latestedSetTime.day(1);
                const now = dayjs();
                const nowMondy = now.day(1);
                if (nowMondy.toDate().getTime() - latestedMondy.toDate().getTime() > 7 * 24 * 60 * 1000) {
                    frontAllow = true;
                }
                else {
                    frontAllow = false;
                }
            }
            if (frontAllow) {
                const res = await mailApi.guidePop();
                console.log('guidePopres', res);
                if (res === null || res === void 0 ? void 0 : res.pop) {
                    setSubAccGuideVisible(true);
                    storeApi.putSync('subAccGuideShowTime', `${new Date().getTime()}`);
                    return;
                }
            }
        }
        setSubAccGuideVisible(false);
    };
    const debounceJudgeShowGuide = debounce((curKey) => {
        judgeShowGuide(curKey);
    }, 500);
    useEffect(() => debounceJudgeShowGuide(activeKey), [activeKey]);
    if (isMatchUnitableCrmHash(activeKey)) {
        activeKeyVisitMap['unitable-crm-v1'] = true;
    }
    const keHuGuanLiEntries = (process.env.BUILD_ISLINGHANG && navigateVersion) || process.env.BUILD_ISEDM
        ? [
            React.createElement("div", { style: isCustomerManageRoute ? visibleStyle : hiddenStyle, hidden: !visibleCUSTOMER_MANAGE, name: L2cCrmPageType.customerManagement, tag: getIn18Text('KEHUGUANLI'), icon: BusinessIcon }, activeKeyVisitMap['unittable-crm-v2'] &&
                (process.env.BUILD_ISEDM ? (React.createElement(UnitableCrm, { foldableMenuVisible: true, tag: getIn18Text('KEHUGUANLI'), icon: BusinessIcon, active: isCustomerManageRoute, menuDataType: "customer" })) : (React.createElement(UnitableCrmLinghang, { foldableMenuVisible: true, tag: getIn18Text('KEHUGUANLI'), icon: BusinessIcon, active: isCustomerManageRoute, menuDataType: "customer" })))),
        ]
        : [];
    const edmEntries = process.env.BUILD_ISEDM
        ? [
            React.createElement("div", { style: isCustomerPerformanceRoute ? visibleStyle : hiddenStyle, sidebarMenuVisible: true, hidden: !visibleCUSTOMER_PROMISE, name: L2cCrmPageType.customerPerformance, tag: version === WAIMAO_PRODUCT_VERSIONS.WEBSITE ? getIn18Text('SHANGPINGUANLI') : getIn18Text('KEHULVYUE'), icon: BusinessExecIcon }, activeKeyVisitMap['unittable-crm-v2-pref'] && (React.createElement(UnitableCrm, { foldableMenuVisible: true, tag: getIn18Text('KEHULVYUE'), icon: BusinessExecIcon, active: isCustomerPerformanceRoute, menuDataType: "performance" }))),
            React.createElement("div", { style: activeKey === 'edm' ? visibleStyle : hiddenStyle, name: "edm", tag: getIn18Text('KEHUKAIFA'), icon: IntelliMarketingIcon, hidden: !visibleCUSTOMER_EXLOIT }, activeKeyVisitMap.edm && React.createElement(IMarketEntry, { name: "edm", activeKey: activeKey })),
            React.createElement("div", { style: activeKey === 'worktable' ? visibleStyle : hiddenStyle, name: "worktable", tag: getIn18Text('GONGZUOTAI'), icon: WorktableIcon, hidden: !visibleWorktable }, activeKeyVisitMap.worktable && React.createElement(Worktable, { activeKey: activeKey, active: activeKey === 'worktable', name: "worktable" })),
            process.env.BUILD_ISEDM ? (React.createElement("div", { style: activeKey === 'coop' ? visibleStyle : hiddenStyle, name: "coop", tag: getIn18Text('XIETONGBANGONG'), icon: CoopIcon }, activeKeyVisitMap.coop && React.createElement(Coop, { name: "coop", activeKey: activeKey, redPoint: true, active: activeKey === 'coop' }))) : null,
            React.createElement("div", { style: activeKey === 'wmData' ? visibleStyle : hiddenStyle, name: "wmData", tag: getIn18Text('KEHUFAXIAN'), icon: BigDataIcon, hidden: !visibleCustomerProspecting, redPoint: true }, activeKeyVisitMap.wmData && React.createElement(BigDataEntry, { name: "wmData", activeKey: activeKey, redPoint: true, active: activeKey === 'wmData' })),
            React.createElement("div", { style: activeKey === 'site' ? visibleStyle : hiddenStyle, name: "site", tag: version === WAIMAO_PRODUCT_VERSIONS.WEBSITE ? getIn18Text('ZHANDIANGUANLIv16') : getIn18Text('ZHANDIANGUANLI'), icon: SiteIcon, hidden: !visilbeSiteManager }, activeKeyVisitMap.site && React.createElement(Site, { name: "site" })),
            React.createElement("div", { style: activeKey === 'enterpriseSetting' ? visibleStyle : hiddenStyle, name: "enterpriseSetting", tag: getIn18Text('QIYESHEZHI'), icon: EnterpriseIcon, hidden: !visilbeEnterpirseSetting }, activeKeyVisitMap.enterpriseSetting && React.createElement(EnterpriseSetting, { name: "enterpriseSetting" })),
            React.createElement("div", { style: activeKey === 'rbac' ? visibleStyle : hiddenStyle, name: "rbac", tag: getIn18Text('QUANXIAN'), hideInTab: true, icon: CustomerIcon }, activeKeyVisitMap.rbac && React.createElement(RbacSetting, { name: "rbac" })),
        ]
        : [];
    const noviceTaskActions = useActions(NoviceTaskActions);
    const { updatePath } = useActions(WebEntryWmActions);
    useEffect(() => {
        if (process.env.BUILD_ISEDM) {
            const id = eventApi.registerSysEventObserver('NoviceTaskRegister', {
                func: event => {
                    noviceTaskActions.registerNoviceTask(event.eventData);
                },
            });
            return () => {
                eventApi.unregisterSysEventObserver('NoviceTaskRegister', id);
            };
        }
    }, []);
    useEffect(() => {
        if (process.env.BUILD_ISEDM) {
            const id = eventApi.registerSysEventObserver('NoviceTaskFinished', {
                func: event => {
                    const { taskName, shouldRemind } = event.eventData;
                    if (shouldRemind) {
                        Modal.success({
                            title: `恭喜你完成「${taskName}」，是否继续完成其他新手引导？`,
                            icon: React.createElement("i", { className: "icon success-icon" }),
                            cancelText: getIn18Text('JIESHU'),
                            okText: getIn18Text('JIXUWANCHENG'),
                            onCancel: showNoviceTaskCloseTip,
                            onOk: () => navigate('#noviceTask?page=noviceTask'),
                        });
                    }
                    else {
                        Modal.success({
                            title: `恭喜你完成「${taskName}」！`,
                            icon: React.createElement("i", { className: "icon success-icon" }),
                            hideCancel: true,
                            okText: getIn18Text('ZHIDAOLE'),
                        });
                    }
                },
            });
            return () => {
                eventApi.unregisterSysEventObserver('NoviceTaskFinished', id);
            };
        }
    }, []);
    useWatermark();
    useEffect(() => {
        const targetPath = process.env.BUILD_ISLINGHANG ? 'setting' : 'enterpriseSetting';
        if (!currentHash.includes(targetPath)) {
            updatePath({ path: location.hash });
        }
    }, [currentHash]);
    useEffect(() => {
        const { data } = storeApi.getSync('OPENED_USER_PORTRAIT', { noneUserRelated: false });
        if (process.env.BUILD_ISEDM && !data) {
            globalSearchApi.getUserPortraitHasInfo().then(res => {
                setUserPortraitHasInfo(res);
            });
        }
    }, []);
    const siteManageIcon = ({}) => (React.createElement("div", { className: style.siteManageIcon + ' sirius-icon-website' },
        React.createElement("img", { src: (websiteInfo === null || websiteInfo === void 0 ? void 0 : websiteInfo.websiteLightIcon) || '' })));
    const doGetWebsiteInfo = async () => {
        try {
            const res = await accountApi.doGetWebsiteInfo();
            if (res) {
                res.websiteUrl = res.websiteUrl += `&from=${encodeURIComponent(window.location.href)}`;
                setWebsiteInfo(res);
            }
        }
        catch (e) {
            console.log('获取网站信息失败', e);
        }
    };
    const showGrubProcess = useMemo(() => activeKey === 'wmData', [activeKey]);
    const showCrmProcess = useMemo(() => activeKey === unitableManageRouteActiveKey || activeKey === unitablePerformanceRouteActiveKey, [activeKey]);
    const FloatButtonRootEl = useMemo(() => {
        if (![WAIMAO_PRODUCT_VERSIONS.WEBSITE, WAIMAO_PRODUCT_VERSIONS.FREE].includes(version) && !navigateVersion) {
            return React.createElement(FloatButtonRoot, { visible: true, showGrubProcess: showGrubProcess, showCrmProcess: showCrmProcess });
        }
        return null;
    }, [version, navigateVersion, showGrubProcess, showCrmProcess]);
    const WaChatWindowEl = useMemo(() => React.createElement(WaChatWindow, null), []);
    const NoticeLiveMessageEl = useMemo(() => React.createElement(NoticeLiveMessage, null), []);
    const ChangeLxTrafficLabelModalEl = useMemo(() => React.createElement(ChangeLxTrafficLabelModal, null), []);
    useEffect(() => {
        doGetWebsiteInfo();
    }, []);
    useEffect(() => {
        appDispatch(getWaFrameworkVersion());
    }, []);
    const { aiMenuVisible, initAiStaffOrTeamInfo } = useAiStaffInfo();
    useEffect(() => {
        if (process.env.BUILD_ISEDM) {
            if (aiMenuVisible && !getAiPageActive(currentHash)) {
                initAiStaffOrTeamInfo();
            }
        }
    }, [aiMenuVisible]);
    return (React.createElement(IndexPageWrapper, { visibleUpgradeApp: visibleUpgradeApp, setVisible: setVisible, upgradeInfo: upgradeInfo, activeKey: activeKey },
        React.createElement(MemoizedTinymceTooltip, null),
        React.createElement(AntdConfig, null),
        React.createElement(SiriusLayout.MainLayout, { l2cCrmSidebarMenuExtra: l2cCrmSidebarMenuExtra },
            React.createElement("div", { style: activeKey === 'mailbox' ? visibleStyle : hiddenStyle, activeKey: activeKey, name: "mailbox", tag: getIn18Text('YOUXIANG'), icon: MailBoxIcon },
                React.createElement(MailEntry, { activeKey: activeKey, name: "mailbox", tag: getIn18Text('YOUXIANG'), icon: MailBoxIcon })),
            visibleAiStaff ? (React.createElement("div", { style: activeKey === 'aiStaff' ? visibleStyle : hiddenStyle, name: "aiStaff", tag: getIn18Text('AYG'), icon: AiStaffIcon }, (activeKey === 'aiStaff' || aiStaffKeepAlive) && React.createElement(AiStaffEntry, { name: "aiStaff", activeKey: activeKey, tag: getIn18Text('AYG'), icon: AiStaffIcon }))) : null,
            visibleAiTeam ? (React.createElement("div", { style: activeKey === 'aiTeam' ? visibleStyle : hiddenStyle, name: "aiTeam", tag: getIn18Text('ATD'), icon: AiStaffIcon }, (activeKey === 'aiTeam' || aiTeamKeepAlive) && React.createElement(AiTeamEntry, { name: "aiTeam", activeKey: activeKey, tag: getIn18Text('ATD'), icon: AiStaffIcon }))) : null,
            visibleWA ? (React.createElement("div", { style: activeKey === 'wa' ? visibleStyle : hiddenStyle, name: "wa", tag: "WA", icon: WaTabIcon }, activeKeyVisitMap.wa && React.createElement(WaEntry, { name: "wa", activeKey: activeKey, tag: "WA", icon: WaTabIcon }))) : null,
            !process.env.BUILD_ISEDM && (React.createElement("div", { style: activeKey === 'schedule' ? visibleStyle : hiddenStyle, activeKey: activeKey, name: "schedule", tag: getIn18Text('RILI'), icon: CalenderIcon }, (process.env.BUILD_ISEDM ? activeKeyVisitMap.schedule : true) && (React.createElement(ScheduleEntry, { activeKey: activeKey, name: "schedule", tag: getIn18Text('RILI'), icon: CalenderIcon })))),
            !process.env.BUILD_ISEDM && React.createElement(ContactEntry, { activeKey: activeKey, name: "contact", tag: getIn18Text('TONGXUNLU'), icon: ContactIcon }),
            visibleIM
                ? !process.env.BUILD_ISEDM && (React.createElement("div", { style: activeKey === 'message' ? visibleStyle : hiddenStyle, activeKey: activeKey, name: "message", tag: getIn18Text('XIAOXI'), icon: IMIcon }, (process.env.BUILD_ISEDM ? activeKeyVisitMap.message : true) && (React.createElement(IMEntry, { activeKey: activeKey, name: "message", tag: getIn18Text('XIAOXI'), icon: IMIcon }))))
                : null,
            !process.env.BUILD_ISEDM && React.createElement(DiskEntry, { name: "disk", activeKey: activeKey, tag: getIn18Text('YUNWENDANG'), icon: DiskTabIcon }),
            webSiteShow && React.createElement("div", { name: "siteManage", "data-targetUrl": websiteInfo === null || websiteInfo === void 0 ? void 0 : websiteInfo.websiteUrl, activeKey: activeKey, tag: websiteInfo === null || websiteInfo === void 0 ? void 0 : websiteInfo.websiteName, icon: siteManageIcon }),
            keHuGuanLiEntries && keHuGuanLiEntries.length ? keHuGuanLiEntries : null,
            process.env.BUILD_ISEDM ? edmEntries : null,
            (process.env.BUILD_ISEDM ? activeKeyVisitMap.setting : true) && (React.createElement(SettingEntry, { activeKey: activeKey, active: activeKey === 'setting', name: "setting", tag: getIn18Text('SHEZHI'), icon: DiskTabIcon, hideInTab: true })),
            process.env.BUILD_ISEDM && (React.createElement("div", { style: Object.assign({ paddingTop: '32px' }, (activeKey === 'phase' ? visibleStyle : hiddenStyle)), activeKey: activeKey, name: "phase", tag: getIn18Text('HUASHUKU'), icon: SystemTaskIcon, hideInTab: true }, activeKey === 'phase' && React.createElement(SalesPitchPage, { name: "phase" }))),
            process.env.BUILD_ISEDM && (React.createElement("div", { style: activeKey === 'systemTask' ? visibleStyle : hiddenStyle, activeKey: activeKey, name: "systemTask", tag: getIn18Text('RENWUZHONGXIN'), icon: SystemTaskIcon, hideInTab: true }, (process.env.BUILD_ISEDM ? activeKeyVisitMap.systemTask : true) && React.createElement(SystemTask, { name: "systemTask" }))),
            process.env.BUILD_ISEDM && (React.createElement("div", { style: activeKey === 'notificationCenter' ? visibleStyle : hiddenStyle, activeKey: activeKey, name: "notificationCenter", tag: getIn18Text('TONGZHIZHONGXIN'), icon: SystemTaskIcon, hideInTab: true }, activeKey === 'notificationCenter' && React.createElement(NotificationCenter, { name: "notificationCenter", active: activeKey === 'notificationCenter' }))),
            process.env.BUILD_ISEDM && (React.createElement("div", { style: activeKey === 'emailInquiry' ? visibleStyle : hiddenStyle, activeKey: activeKey, name: "emailInquiry", tag: getIn18Text('QUANBUXUNPAN'), icon: SystemTaskIcon, hideInTab: true }, (process.env.BUILD_ISEDM ? activeKeyVisitMap.emailInquiry : true) && React.createElement(EmailInquiry, { name: "emailInquiry" }))),
            process.env.BUILD_ISEDM && (React.createElement("div", { style: activeKey === 'noviceTask' ? visibleStyle : hiddenStyle, activeKey: activeKey, name: "noviceTask", tag: getIn18Text('XINSHOURENWU'), icon: SystemTaskIcon, hideInTab: true }, (process.env.BUILD_ISEDM ? activeKeyVisitMap.noviceTask : true) && React.createElement(NoviceTask, { name: "noviceTask" }))),
            process.env.BUILD_ISLINGHANG && navigateVersion && (React.createElement("div", { style: activeKey === TopMenuPath.backgroundCheck ? visibleStyle : hiddenStyle, name: TopMenuPath.backgroundCheck, tag: getIn18Text('KEHUBEIDIAO'), icon: BackgroundCheckIcon, hidden: !visibleCustomerBackgroundCheck },
                React.createElement(BackgroundCheck, { name: TopMenuPath.backgroundCheck })))),
        React.createElement(KeyboardModel, { visible: visibleKeyboardModel, onCancel: () => {
                setVisibleKeyboardModel(false);
            } }),
        process.env.BUILD_ISEDM && React.createElement(Notice, { notice: edmNotice }),
        process.env.BUILD_ISEDM && FloatButtonRootEl,
        process.env.BUILD_ISEDM && React.createElement(AiAssiBallEntry, null),
        process.env.BUILD_ISEDM && React.createElement(GlobalAdvertNotification, null),
        process.env.BUILD_ISEDM && React.createElement("div", { id: "unidrawer-root" }),
        process.env.BUILD_ISEDM && version === 'FASTMAIL_EXPIRED' && (React.createElement(Modal, { destroyOnClose: true, getContainer: false, maskStyle: {
                left: 68,
            }, visible: version === WAIMAO_PRODUCT_VERSIONS.FASTMAIL_EXPIRED &&
                (location.hash.includes('#wmData') ||
                    location.hash.includes('#intelliMarketing') ||
                    location.hash.includes('#edm') ||
                    location.hash.includes('unitable') ||
                    location.hash.includes('#aiStaff') ||
                    location.hash.includes('#aiTeam') ||
                    location.hash.includes('#site')), title: null, footer: null, keyboard: false, maskClosable: false, closable: false },
            React.createElement("p", null, getIn18Text('NINDEWAIMAOTONGYIGUO')))),
        process.env.BUILD_ISEDM && (version === WAIMAO_PRODUCT_VERSIONS.FREE || navigateVersion) && (React.createElement(Modal, { destroyOnClose: true, getContainer: false, maskStyle: {
                left: 68,
            }, visible: (version === WAIMAO_PRODUCT_VERSIONS.FREE || navigateVersion) &&
                (location.hash.includes('#wmData') ||
                    location.hash.includes('#intelliMarketing') ||
                    location.hash.includes('#edm') ||
                    location.hash.includes('unitable') ||
                    location.hash.includes('#site')), title: null, footer: null, keyboard: false, maskClosable: false, closable: false },
            React.createElement("p", null,
                getIn18Text('NIHAIWEIGOUMAIWAIMAO'),
                React.createElement("button", { className: style.learnmore, onClick: () => {
                        window === null || window === void 0 ? void 0 : window.open(`${getWaimaoTrailEntryHost()}#wmData?page=globalSearch`);
                    } }, getIn18Text('FANGWENWANGYEBANWAIMAO'))))),
        process.env.BUILD_ISEDM && React.createElement(NpsSurveyNew, null),
        process.env.BUILD_ISEDM && React.createElement(MarketingModalList, null),
        process.env.BUILD_ISEDM && !userPortraitHasInfo && (React.createElement(UserPortraitModal, { closeBack: () => {
                setUserPortraitHasInfo(true);
                storeApi.putSync('OPENED_USER_PORTRAIT', '1', {
                    noneUserRelated: false,
                });
            } })),
        process.env.BUILD_ISEDM && React.createElement(AlertPublishSiteModal, null),
        process.env.BUILD_ISEDM && React.createElement(ChangeLxTrafficLabelModal, null),
        process.env.BUILD_ISEDM && React.createElement(NoticeLiveMessage, null),
        subAccGuideVisible && React.createElement(SubAccEntryGuide, { visible: subAccGuideVisible, setVisible: setSubAccGuideVisible }),
        process.env.BUILD_ISEDM && WaChatWindowEl,
        process.env.BUILD_ISEDM && NoticeLiveMessageEl,
        process.env.BUILD_ISEDM && ChangeLxTrafficLabelModalEl));
};
export default IndexPage;
console.info('---------------------end index page------------------');
